export default __webpack_public_path__ + "static/BPA Broadstairs-56d9aa6aaddea4eed36f5fd84d948bdf.png";